import { connect } from 'react-redux'
import * as action from '../../state/file-upload/action'
import * as customerAction from '../../state/detail/action'
import * as selector from '../../state/file-upload/selector'
import CustomerFileUpload from './CustomerFileUpload'
import { FILE_TYPE_X_RAY } from '../../state/const'
import { CUSTOMER_XRAY_FILE_UPLOAD } from '../../ui-definition/customer-ui'


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        fetching: selector.selectIsFetching(state, FILE_TYPE_X_RAY),
        fileType: FILE_TYPE_X_RAY,
        widgetId: CUSTOMER_XRAY_FILE_UPLOAD,
    }
}

const mapDispatchToProps = {
    uploadCustomerFile: action.uploadCustomerFile,
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerFileUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/scan-file-upload/XRayFileUploadContainer.js